import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Permissioncategory } from '../models/index';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class PermissioncategoryService {
    constructor(private http: HttpClient) {
    }

    getAllPermission_category() {
        return this.http.get<any>(AppConstants.SITE_URL +'permission_category/get_all_permission_categorys');
    }
    getPermission_categorys(permission_category: Permissioncategory) {
        return this.http.post<any>(AppConstants.SITE_URL +'permission_category/get_permission_categorys', permission_category);
    }
    getPermission_categoryById(id) {
        return this.http.post<any>(AppConstants.SITE_URL +'permission_category/getPermission_categoryById', { id: id });
    }
    savePermission_category(permission_category) {
        return this.http.post<any>(AppConstants.SITE_URL +'permission_category/save_permission_category', permission_category);
    }



}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/services/permission_category.service.ts